import { useState } from "react";
import PropTypes from "prop-types";
import { Input } from "antd";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";

const EditableTypeItem = ({ productType, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(productType.name);

  const handleStartEdit = (e) => {
    e.stopPropagation();
    setIsEditing(true);
    setEditValue(productType.name);
  };

  const handleSave = (e) => {
    e.stopPropagation();
    if (editValue.trim() && editValue !== productType.name) {
      onSave(editValue.trim());
    }
    setIsEditing(false);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    setEditValue(productType.name);
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave(e);
    } else if (e.key === "Escape") {
      handleCancel(e);
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="type-header" onClick={handleClick}>
      {productType.image && (
        <img
          src={productType.image}
          alt={productType.name}
          className="type-image"
        />
      )}
      {isEditing ? (
        <>
          <Input
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onClick={handleClick}
            autoFocus
            style={{ flex: 1, marginRight: 8 }}
          />
          <CheckOutlined
            onClick={handleSave}
            style={{ color: "#52c41a", marginRight: 8, fontSize: 16 }}
          />
          <CloseOutlined
            onClick={handleCancel}
            style={{ color: "#ff4d4f", fontSize: 16 }}
          />
        </>
      ) : (
        <>
          <span className="type-name">{productType.name}</span>
          <EditOutlined
            onClick={handleStartEdit}
            style={{ color: "#1890ff", fontSize: 16 }}
          />
        </>
      )}
    </div>
  );
};

EditableTypeItem.propTypes = {
  productType: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string,
    machineSeries: PropTypes.array,
  }).isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditableTypeItem;
